import { TextFieldProps } from '@forgeglobal/design-framework';
import { FieldRenderProps } from 'react-final-form';
import MaskedTextField from '../MaskedTextField';

import { maskitoPhone } from '@maskito/phone';
import metadata from 'libphonenumber-js/min/metadata';

const options = maskitoPhone({
  countryIsoCode: 'US',
  metadata,
  strict: true,
});

const PhoneNumberTextField = (
  props: TextFieldProps<any>,
): React.ReactElement<FieldRenderProps<any, HTMLInputElement>> => {
  const inputValue = props.input?.value || '';
  const normalizedValue = inputValue || '+1 ';

  const enhancedProps = {
    ...props,
    input: {
      ...props.input,
      value: normalizedValue,
    },
  };

  return <MaskedTextField {...enhancedProps} options={options} />;
};

export default PhoneNumberTextField;
